import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { Fragment, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import SubjectAttributesForm from './form';
import {
  RegistrationBewareFormVM,
  SubjectAttributesVM,
} from 'mutation/view-models/registration-beware';
import { useListener } from 'shell/hooks/use-bus';

interface AccordionSubjectAttributesProps {
  isBeware?: boolean;
}

const AccordionSubjectAttributes = ({
  isBeware,
}: AccordionSubjectAttributesProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  useListener('RESET_ANOMALIES', () => {
    setOpen(false);
  });

  useListener<boolean>('ACCORDION_OPEN', (openAccordion) => {
    setOpen(openAccordion || false);
  });

  const formContext = useFormikContext<RegistrationBewareFormVM>();

  const onFieldSubjectAttributesChange = useEventCallback(
    (key: keyof SubjectAttributesVM, value: SubjectAttributesVM[keyof SubjectAttributesVM]) => {
      formContext.setFieldValue('subjectAttributes', {
        ...(formContext.values?.subjectAttributes || {}),
        [key]: value,
      });
    }
  );

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-person-content"
          id="panel-person-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Attributi soggetto</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <SubjectAttributesForm
            isBeware={isBeware}
            values={formContext.values?.subjectAttributes}
            onChange={onFieldSubjectAttributesChange}
            errors={formContext.errors?.subjectAttributes as FormikErrors<SubjectAttributesVM>}
            touched={
              formContext.touched
                ?.subjectAttributes as unknown as FormikTouched<SubjectAttributesVM>
            }
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionSubjectAttributes.displayName = 'Accordion subject attributes component';

export default AccordionSubjectAttributes;
